export default __webpack_public_path__ + "static/media/Silver_60F_x264.38725576.mp4";